export default __webpack_public_path__ + "static/helles_shadow-02d5eac1a725d92e5e21d754a9797f37.png";